// extracted by mini-css-extract-plugin
export default {"all_wrp":"AllPage_all_wrp__UQsNz"};